var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},_vm._l((_vm.images),function(image,index){return _c('img',{key:index,staticClass:"carousel-image",class:{ active: _vm.currentIndex === index },attrs:{"alt":"Carrossel","src":require(`../assets/${image}`)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }